const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEFF1"
    },
    d: "M496,432.004H272c-8.832,0-16-7.136-16-16s0-311.168,0-320s7.168-16,16-16h224 c8.832,0,16,7.168,16,16v320C512,424.868,504.832,432.004,496,432.004z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M432,176.004H272c-8.832,0-16-7.136-16-16s7.168-16,16-16h160c8.832,0,16,7.168,16,16 S440.832,176.004,432,176.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M432,240.004H272c-8.832,0-16-7.136-16-16s7.168-16,16-16h160c8.832,0,16,7.168,16,16 S440.832,240.004,432,240.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M432,304.004H272c-8.832,0-16-7.136-16-16c0-8.864,7.168-16,16-16h160c8.832,0,16,7.168,16,16 S440.832,304.004,432,304.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M432,368.004H272c-8.832,0-16-7.136-16-16s7.168-16,16-16h160c8.832,0,16,7.168,16,16 S440.832,368.004,432,368.004z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1565C0"
    },
    d: "M282.208,19.716c-3.648-3.072-8.544-4.352-13.152-3.424l-256,48C5.504,65.7,0,72.324,0,80.004v352 c0,7.68,5.472,14.304,13.056,15.712l256,48c0.992,0.192,1.952,0.288,2.944,0.288c3.712,0,7.328-1.28,10.208-3.68 c3.68-3.04,5.792-7.552,5.792-12.32v-448C288,27.236,285.888,22.756,282.208,19.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M207.904,337.796c-0.832,7.328-6.592,13.184-13.92,14.08c-0.672,0.096-1.312,0.128-1.984,0.128 c-6.592,0-12.608-4.096-14.976-10.368L144,253.572l-33.024,88.064c-2.56,6.848-9.28,11.04-16.704,10.272 c-7.264-0.768-13.088-6.4-14.112-13.664l-16-112c-1.248-8.704,4.832-16.832,13.568-18.08c8.768-1.28,16.864,4.832,18.112,13.568 l7.136,50.048l26.016-69.408c4.672-12.48,25.28-12.48,29.984,0l24.512,65.344l8.608-77.504c0.992-8.768,9.12-15.072,17.664-14.144 c8.8,1.024,15.104,8.928,14.144,17.696L207.904,337.796z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.4a571cf3a3f7db8f2bbdccfd9b780b3c.svg";
export { ForwardRef as ReactComponent };